import React from 'react'
import { FaPlus } from "react-icons/fa6";
import { FaEquals } from "react-icons/fa";
import './tranining.css'
import CircularProgressBar from './CircularProgressBar.jsx';
import Address from './Address.jsx';
import LazyImage from '../../LazyImage.jsx';

const Training = (props) => {
    const{img1,img2,img3,img4,img5}=props.Img
  return (
    <div>
        <div className="footer">
            <div><h3>Training Process</h3></div>
            <hr/>
            <div className='footer-container'>
                <div className="process-step">
                    <LazyImage src={img1} alt="Theory" /><span className='process-separator'><FaPlus /></span>
                    <p className='process-text'>Theory</p>
                </div>
                <div className="process-step">
                    <LazyImage src={img2} alt="Practicals" /><span className='process-separator'><FaPlus /></span>
                    <p className='process-text'>Practicals</p>
                </div>
                <div className="process-step">
                    <LazyImage src={img3} alt="Assignments" /><span className='process-separator'><FaPlus /></span>
                    <p className='process-text'>Assignments</p>
                </div>
                <div className="process-step">
                    <LazyImage src={img4} alt="Certification" /><span className='process-separator'><FaEquals /></span>
                    <p className='process-text'>Certification</p>
                </div>
                <div className="process-step expert-step">
                    <LazyImage src={img5} alt="Expert" className='icon-expert'/>
                    <p className='process-text expert-text'>Expert</p>
                </div>
            </div>
            <hr/>
            <div>
                <h3>Trained Students</h3>
                <h3 id='students'>800+</h3>
            </div>

            <div className="strength">
                <div><h5>Training Infrastructure</h5>
                <span style={{margin:'20px 0px 0px 25px', display:'flex'}}><CircularProgressBar percentage={100} size={150} strokeWidth={12} marginTop={20} duration={1500} /></span>
                </div>

                <div><h5>Teaching skill</h5>
                    <span><CircularProgressBar percentage={100} size={150} strokeWidth={12} marginTop={20} duration={2500} /></span>
                </div>
                <div><h5>Certification</h5>
                    <span><CircularProgressBar percentage={100} size={150} strokeWidth={12} marginTop={20} duration={3000} /></span>
                </div>
            </div>
        </div>
        <div className='address-container'>
            {/* <Address ftrlogo={ftrlogo}/> */}
            <Address/>
        </div>
    </div>
  )
}

export default Training